<template>
  <div class="east-cred-layout">
    <div class="east-cred-layout__top">
      <nav class="nav">
        <div class="nav-left"><div class="nav-item"></div></div>
        <div class="nav-center">
          <div class="nav-item nav-item--title">
            <span>{{ $t('label.manage_days') }}</span>
          </div>
        </div>
        <div class="nav-right"><div class="nav-item"></div></div>
      </nav>
    </div>

    <div class="east-cred-layout__center is-scrollable">
      <div class="east-cred-layout__center__content">
        <div class="manage-program-days">

          <div class="form-east-block-layout">

            <template v-if="_get(ProgramDetails, 'saveError')">
              <el-row type="flex" style="align-self: stretch">
                <el-col :span="24">
                  <nuttrema-form-alert :error="_get(ProgramDetails, 'saveError')" style="margin: 1em 0.5em 0"></nuttrema-form-alert>
                </el-col>
              </el-row>
            </template>

            <section>
              <h4 class="section-title">{{ $t('label.program_info') }}</h4>
              <div class="section-items">
                <div class="manage-program-days__diet-info">
                  <div class="diet-info--date" v-if="startDate">
                    <div>
                      <p><span class="ttl">{{ $t('label.start_date') }}</span>: {{ $d(new Date(startDate), 'short') }}</p>
                      <p><span class="ttl">{{ $t('label.end_date') }}</span>: {{ $d(moment(startDate).add(list.length - 1, 'day').toDate(), 'short') }}</p>
                    </div>
                  </div>
                  <div class="diet-info--duration">
                    <div>
                      <p><span class="ttl">{{ $t('label.duration_days') }}</span>: {{ list.length }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="form-east-block-layout">
            <section>
              <h4 class="section-title">{{ $t('label.list_of_days') }}</h4>
              <div class="section-items">
                <draggable class="manage-program-days-list" v-model="list" @end="onEnd">
                  <div
                     v-for="(day, index) in list"
                     class="manage-program-days__day"
                    :class="{ 'is-addded': day.added, 'is-current': day.id == dayID }"
                    :key="day.id">
                    <div class="day__current" v-if="day.id == dayID">
                      <a title="The currently active day can't be removed from program schedules."></a>
                    </div>
                    <div class="day__move">
                      <i class="far fa-arrows-v"></i>
                    </div>
                    <div class="day__date">
                      <div class="day__date__label" v-if="startDate">
                        <p class="day__date__label--month">{{ moment(startDate).add(index, 'day').format('MMM') }}</p>
                        <p class="day__date__label--day">{{ moment(startDate).add(index, 'day').format('Do') }}</p>
                        <p v-if="day.id && day.date !== moment(startDate).add(index, 'day').format('YYYY-MM-DD')" class="day__date__label--old-date">{{ day.date | moment('Do MMM') }}</p>
                      </div>
                      <div class="day__date__label" v-else>
                        <p class="day__date__label--day-of-diet">&nbsp;</p>
                        <p class="day__date__label--day">{{ $t('label.day') }} {{ index + 1 }}</p>
                        <p v-if="day.id && day.dayNumber !== index + 1" class="day__date__label--old-date">{{ $t('label.day') }} {{ day.dayNumber }}</p>
                      </div>
                    </div>
                    <div class="day__description">
                      <div class="description--title">
                        <input-edit-in-place
                           class="ttl is-transparent"
                           name="title"
                          :params="day.dayNumber"
                          :placeholder="$t('label.click_to_add_day_title')"
                          :value="day.title"
                          @edited="onTitleOrNoteUpdate">
                        </input-edit-in-place>
                      </div>
                      <div class="description--note">
                        <input-edit-in-place
                           class="note is-transparent"
                           name="note"
                          :params="day.dayNumber"
                          :placeholder="$t('label.click_to_add_day_note')"
                          :value="day.note"
                          @edited="onTitleOrNoteUpdate">
                        </input-edit-in-place>
                      </div>
                      <div class="description--schedules"></div>
                    </div>
                    <div class="day__action">
                      <el-button
                         v-if="day.id != dayID"
                         size="mini"
                         type="danger"
                        :plain="true"
                        :disabled="list.length === 1"
                        @click="removeFromList(day.dayNumber)">
                        {{ $t('label.remove') }}
                      </el-button>
                    </div>
                  </div>
                  <!-- end ~ manage-program-days__day -->
                </draggable>
              </div>
            </section>
          </div>

          <template v-if="willBeDeletedList.length > 0">
            <div class="form-east-block-layout">
              <section>
                <h4 class="section-title">{{ $t('label.will_be_deleted') }}</h4>
                <div class="section-items">
                  <div class="manage-program-days-list">
                    <div class="manage-program-days__day is-will-be-deleted" v-for="day in willBeDeletedList" :key="day.id">
                      <div class="day__move">
                        <i class="far fa-arrows-v"></i>
                      </div>
                      <div class="day__date">
                        <div class="day__date__label" v-if="day.date">
                          <p class="day__date__label--month">{{ day.date | moment('MMM') }}</p>
                          <p class="day__date__label--day">{{ day.date | moment('Do') }}</p>
                        </div>
                        <div class="day__date__label" v-else>
                          <p class="day__date__label--month">&nbsp;</p>
                          <p class="day__date__label--day">{{ $t('label.day') }} {{ day.dayNumber  }}</p>
                        </div>
                        <template></template>
                      </div>
                      <div class="day__description">
                        <div class="description--title">
                          <input-edit-in-place
                             class="ttl is-transparent"
                             name="title"
                            :disabled="true"
                            :placeholder="$t('label.click_to_add_day_title')"
                            :value="day.title">
                          </input-edit-in-place>
                        </div>
                        <div class="description--note">
                          <input-edit-in-place
                             class="note is-transparent"
                             name="note"
                            :disabled="true"
                            :placeholder="$t('label.click_to_add_day_note')"
                            :value="day.note">
                          </input-edit-in-place>
                        </div>
                        <div class="description--schedules"></div>
                      </div>
                      <div class="day__action">
                        <el-button
                           size="mini"
                           type="warning"
                          :plain="true"
                          @click="cancelRemove(day.dayNumber)">
                          {{ $t('label.cancel') }}
                        </el-button>
                      </div>
                    </div>
                    <!-- end ~ manage-program-days__day -->
                  </div>
                </div>
              </section>
            </div>
          </template>
        </div>
        <!-- end ~ manage_diet_days -->
      </div>
      <!-- end ~ east-cred-layout__center__content -->
    </div>

    <div class="east-cred-layout__bottom">
      <nav class="nav">
        <div class="nav-left">
          <div class="nav-item">
            <popover-question-alert
               popoverWidth="280"
               buttonTitle="label.save_changes"
               popoverText="label.remove_schedule_day_note"
              :loading="ProgramDetails.saving"
              :popoverShouldShow="willBeDeletedList.length > 0"
              @confirmed="handleFormSubmit">
            </popover-question-alert>
            <el-button
               size="small"
               type="text"
              @click="handleFormCancel">
              {{ $t('label.cancel') }}
            </el-button>
          </div>
        </div>
        <div class="nav-right nav-right--grow-less">
          <div class="nav-item">
            <permissions-control-wrapper
               action="label.purchase_new_subscription"
              :required-general="$PERMISSIONS_GENERAL.EDIT_SPECIAL"
              :permissions="_get(ProgramDetails, 'meta.permissions')">
              <el-button
                slot="allowed"
                type="nuttrema-orange"
                size="small"
                icon="far fa-plus" theme="add-button"
                class="is-icon"
                @click="handleAddNewDay">
                {{ $t('label.add_new_day') }}
              </el-button>

              <el-button
                slot="not-allowed"
                type="info"
                size="small"
                class="is-icon"
                icon="far fa-lock-alt">
                {{ $t('label.add_new_day') }}
              </el-button>
            </permissions-control-wrapper>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { each, get, isNil, findIndex, find, random, assign, omitBy, cloneDeep } from 'lodash';
import draggable from 'vuedraggable';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';
import InputEditInPlace from 'components/ui/input/nuttrema-input-edit-in-place';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';

export default {
  name: 'cmpt-manage-program-days',
  props: {
    id: {
      required: true,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    ProgramDetails: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    draggable,
    InputEditInPlace,
    PopoverQuestionAlert,
    NuttremaLayoutWestThreeVertical,
    NuttremaFormAlert,
  },
  data() {
    return {
      startDate: null,
      list: [],
      originalList: [],
      willBeDeletedList: [],
    };
  },
  methods: {
    moment,
    onTitleOrNoteUpdate(data) {
      const name = data.name;
      const value = data.value;
      const dayNumber = data.params;
      const day = find(this.list, item => item.dayNumber === dayNumber);
      if (day) Vue.set(day, name, value);
    },
    handleFormSubmit() {
      const payload = this.getPayload();
      console.log('handleFormSubmit', payload);
      this.$emit('submit', payload);
    },
    handleFormCancel() {
      this.willBeDeletedList = [];
      this.list = cloneDeep(this.originalList);
      this.$emit('cancel');
    },
    handleAddNewDay() {
      this.list.push({
        id: null,
        date: 'dummy',
        newDate: null,
        dayNumber: random(10000, 100000),
        title: null,
        note: null,
        added: true,
      });
    },
    addToList(day) {
      this.list.push({
        id: day.id,
        date: day.day,
        newDate: null,
        dayNumber: day.day_number,
        title: day.title,
        note: day.note,
        added: false,
      });
    },
    removeFromList(dayNumber) {
      const dayIndex = findIndex(this.list, item => item.dayNumber === dayNumber);
      if (dayIndex !== -1) {
        const day = this.list[dayIndex];
        if (day.added) {
          this.list.splice(dayIndex, 1);
        } else {
          this.willBeDeletedList.push(day);
          this.list.splice(dayIndex, 1);
        }
      }
    },
    cancelRemove(dayNumber) {
      const dayIndex = findIndex(this.willBeDeletedList, item => item.dayNumber === dayNumber);
      if (dayIndex !== -1) {
        const day = this.willBeDeletedList[dayIndex];
        this.list.push(day);
        this.willBeDeletedList.splice(dayIndex, 1);
      }
    },
    reCreateList() {
      const startDate = get(this.ProgramDetails, 'data.start_date');
      each(this.list, (day, index) => {
        if (!isNil(startDate)) {
          const reorderDate = startDate ? moment(startDate).add(index, 'day') : null;
          Vue.set(day, 'newDate', moment(reorderDate).format('YYYY-MM-DD'));
        }
      });
    },
    onEnd() {
      this.reCreateList();
    },
    getPayload() {
      const payload = {
        data: [],
      };
      each(this.list, (item) => {
        const data = {
          id: item.id,
          title: item.title,
          note: item.note,
        };
        payload.data.push(assign({ delete: false }, omitBy(data, isNil)));
      });
      each(this.willBeDeletedList, (item) => {
        const data = {
          id: item.id,
          title: item.title,
          note: item.note,
        };
        payload.data.push(assign({ delete: true }, omitBy(data, isNil)));
      });
      return JSON.parse(JSON.stringify(payload));
    },
  },
  created() {
    this.startDate = get(this.ProgramDetails, 'data.start_date');

    const programDays = get(this.ProgramDetails, 'data.ProgramDays', []);
    each(programDays, (day) => {
      this.addToList(day);
    });
    this.originalList = cloneDeep(this.list);
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import '~styles/mixins/gradients';

  .manage-program-days {
    overflow-y: scroll;
    .ui-element {
      font-weight: 500;
      &:first-child {
        margin-top: 1em;
      }
    }

    .manage-program-days__diet-info {
      display: flex;
      align-self: stretch;
      justify-content: center;
      flex-direction: column;
      > * {
        flex-grow: 1;
        .ttl {
          font-weight: 600;
        }
      }
    }

    .manage-program-days-list {

      $default-bg: $element-ui-color-primary;
      // $default-bg: #D4D4D4;
      $added-bg: $secondary-two-color-light;
      $removed-bg: $brand-danger;
      $hover-bg: $element-ui-color-primary;

      display: flex;
      align-self: stretch;
      flex-direction: column;


      .manage-program-days__day {
        display: flex;
        margin-bottom: 0.5em;
        align-self: stretch;
        align-items: center;
        justify-content: space-between;
        background-color: rgba($default-bg, 0.15);
        border-radius: 0.25em;
        position: relative;

        .day__current {
          width: 3em;
          top: 0.5em;
          right: -0.7em;
          height: 0.5em;
          position: absolute;
          transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          background-color: #20a0ff;
          -webkit-transform: rotate(45deg);
          box-shadow: 0 2px 5px rgba(0,0,0,0.25);
          @include gradient-horizontal(#20a0ff, #3273dc);
          clip-path: polygon(17% 0, 85% 0, 100% 100%, 0% 100%);
          a {
            position: absolute;
            top: 0; left: 0; bottom: 0; right: 0;
          }
        }

        .day__move {
          opacity: 0.15;
          display: flex;
          padding: 0 0.5em;
          transition: all 0.25s linear;
          -o-transition: all 0.25s linear;
          -moz-transition: all 0.25s linear;
          -webkit-transition: all 0.25s linear;
          &:hover {
            opacity: 1;
            cursor: pointer;
          }

          &.is-disabled {
            opacity: 0;
            &:hover {
              opacity: 0;
              cursor: inherit;
            }
          }
        }

        .day__date {
          display: flex;
          align-self: stretch;
          height: 5em;
          .day__date__label {
            width: 5em;
            text-align: center;
            padding: 0.25em 0.5em;
            background-color: rgba($default-bg, 0.25);
            box-shadow: inset  0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.25),
                        inset -0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.25);
            .day__date__label--month {
              font-weight: 500;
            }
            .day__date__label--day-of-diet {
              font-weight: 500;
              font-size: 0.9rem;
            }
            .day__date__label--day {
              font-weight: 600;
              line-height: 1.25;
              font-size: 1.1rem;
            }
            .day__date__label--old-date {
              color: $note-color;
              font-size: 0.85rem;
              text-decoration: line-through;
            }
          }
        }

        .day__description {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0.25em 0.5em;
          z-index: 1;
          .description--title {

          }
          .description--note {}
        }

        .day__copy {
          z-index: 0;
          font-size: 4rem;
          font-weight: 600;
          text-align: right;
          right: 0; left: 0;
          position: absolute;
          padding-right: 0.5em;
          text-transform: uppercase;
          color: rgba($removed-bg, 0.05);
        }

        .day__action {
          display: flex;
          align-self: center;
          padding: 0.25em 0.5em;
        }

        &:hover {
          .day__move {
            opacity: 1;
            &.is-disabled {
              opacity: 0;
              &:hover {
                opacity: 0;
                cursor: inherit;
              }
            }
          }
        }

        &.is-will-be-deleted {
          background-color: rgba($removed-bg, 0.15);
          .day__move {
            opacity: 0;
          }
          .day__date .day__date__label {
            background-color: rgba($removed-bg, 0.25);
          }
        }

        &.is-addded {
          background-color: rgba($added-bg, 0.20);
          .day__date .day__date__label {
            background-color: rgba($added-bg, 0.35);
          }
        }

        &.is-current {
          background-color: rgba($default-bg, 0.35);
          .day__date .day__date__label {
            background-color: rgba($default-bg, 0.45);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/manage/cmpt-manage-program-days.vue